/* src/app/admin/client/client-detail/client-detail.component.scss */
.action-buttons button {
  margin-right: 8px;
  margin-top: 10px;
}
.button-back {
  border-color: #747679;
  color: #747679;
}
/*# sourceMappingURL=client-detail.component-XHXSGUWL.css.map */
